import http from "../httpService";
const url = "/UrlLookup/DeleteURL";

http.setAuthorizationToken();

export function deleteMaliciousUrl(id: number) {
  return http.delete(`${url}/${id}`);
}
